import * as CONSTANT from "../../utils/actionTypes";
import UNIVERSAL from "../../utils/config";
import { setLoader, unsetLoader } from "../../store/actions/loaderActions";
import { set_snack_bar } from "../../store/actions/snackbarActions";

import { viewLinkById } from "../admin/adminActions";

export function loginFetch(email, password) {
  return (dispatch) => {
    dispatch(setLoader());
    return fetch(UNIVERSAL.BASEURL + "user/login", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email: email,
        password: password,
      }),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        if (
          responseJson.statusCode === 201 ||
          responseJson.statusCode === 200
        ) {
          dispatch({ type: CONSTANT.LOGIN, payload: responseJson.data.result });
          if (responseJson.data.result.access === "SA") {
            dispatch(
              viewLinkById(
                responseJson.data.result._id,
                responseJson.data.token
              )
            );
          }

          dispatch(setAdminLogin(responseJson));

          dispatch(unsetLoader());
          dispatch(set_snack_bar(true, responseJson.message));
        } else {
          dispatch(unsetLoader());
          dispatch(set_snack_bar(true, responseJson.message));
        }
      })
      .catch((error) => {
        dispatch(unsetLoader());
        dispatch(set_snack_bar(true, "Check Your Internet Connection"));

      });
  };
}

export function getUseByAuthToken(token) {
  return (dispatch) => {
    dispatch(setLoader());
    return fetch(UNIVERSAL.BASEURL + "user/getUserDetailsAuthByToken", {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        token: token,
      },
    })
      .then((response) => response.json())
      .then((responseJson) => {
        if (
          responseJson.statusCode === 201 ||
          responseJson.statusCode === 200
        ) {
          dispatch({
            type: CONSTANT.PROFILEDEATAILS,
            payload: responseJson.data,
          });
          dispatch(unsetLoader());
        } else {
          dispatch(unsetLoader());
        }
      })
      .catch((error) => {
        dispatch(unsetLoader());
        dispatch(set_snack_bar(true, "Check Your Internet Connection"));

      });
  };
}

export function fetchToken(token) {
  return (dispatch) => {
    dispatch(setLoader());
    return fetch(UNIVERSAL.BASEURL + "user/getUserToken", {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        token: token,
      },
    })
      .then((response) => response.json())
      .then((responseJson) => {
        if (
          responseJson.statusCode === 200 ||
          responseJson.statusCode === 201
        ) {
          dispatch(setTokenData(responseJson.data));
          dispatch(unsetLoader());
        } else {
          localStorage.clear();
          dispatch(onLogout(token));
          dispatch(unsetLoader());
        }
      })
      .catch((error) => {
        dispatch(unsetLoader());
        dispatch(set_snack_bar(true, "Check Your Internet Connection"));

      });
  };
}

export function forgotpassword(email) {
  return (dispatch) => {
    dispatch(setLoader());
    return fetch(UNIVERSAL.BASEURL + "user/forgotpassword", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email: email,
      }),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        if (
          responseJson.statusCode === 201 ||
          responseJson.statusCode === 200
        ) {
          dispatch({
            type: CONSTANT.PASSWORD_GENERATE,
            payload: responseJson.message,
          });
          dispatch(unsetLoader());
        } else if (
          responseJson.statusCode === 401 ||
          responseJson.statusCode === 403
        ) {

          dispatch(unsetLoader());
        } else {
          dispatch({
            type: CONSTANT.PASSWORD_GENERATE,
            payload: responseJson.message,
          });
          dispatch(unsetLoader());
        }
      })
      .catch((error) => {
        dispatch(unsetLoader());
        dispatch(set_snack_bar(true, "Check Your Internet Connection"));

      });
  };
}

export function passwordChange(token, user_id, oldpassword, newpassword) {
  return (dispatch) => {
    dispatch(setLoader());

    return fetch(UNIVERSAL.BASEURL + "user/changepassword", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        token: token,
      },
      body: JSON.stringify({
        user_id,
        password: oldpassword,
        newpassword,
      }),
    })
      .then((response) => response.json())
      .then((responseJson) => {
        if (
          responseJson.statusCode === 201 ||
          responseJson.statusCode === 200
        ) {
          dispatch(unsetLoader());
          dispatch(onLogout(token));
          dispatch(set_snack_bar(true, responseJson.message));
        } else {
          dispatch(unsetLoader());
          dispatch(set_snack_bar(true, responseJson.message));
        }
      })
      .catch((error) => {
        dispatch(unsetLoader());
        dispatch(set_snack_bar(true, "Check Your Internet Connection"));

      });
  };
}



export function handleDrawerToggle(mobileOpen) {
  mobileOpen = !mobileOpen;
  return {
    type: CONSTANT.HANDLEDRAWER,
    payload: mobileOpen,
  };
}

export function setAdminLogin(payload) {
  payload.data.result.token = payload.data.token;

  localStorage.setItem("token", payload.data.token);
  localStorage.setItem("type", payload.data.result.access);

  let user_id = "";

  if (payload.data.result.access === "SA") {
    user_id = payload.data.result._id;
  } else {
    user_id = payload.data.result.admin_id;
  }

  return {
    type: CONSTANT.LOGIN,
    payload: payload.data.result,
    user_id: user_id,
  };
}

export function setTokenData(payload) {
  payload.user_id.token = payload.token;
  localStorage.setItem("token", payload.token);
  localStorage.setItem("type", payload.user_id.access);
  let user_id = "";
  if (payload.user_id.access === "SA") {
    user_id = payload.user_id._id;
  } else {
    user_id = payload.user_id.admin_id;
  }
  return {
    type: CONSTANT.LOGIN,
    payload: payload.user_id,
    user_id: user_id,
  };
}

export function onLogout(token) {
  return (dispatch) => {
    dispatch(setLoader());
    return fetch(UNIVERSAL.BASEURL + "user/logout", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        token
      },
    })
      .then((response) => response.json())
      .then((responseJson) => {
        if (responseJson.statusCode === 200 || responseJson.statusCode === 201) {
          localStorage.clear();
          dispatch(unsetLoader());
          dispatch({ type: CONSTANT.LOGOUT });

          if (window.location) {
            window.location.href = "/";
          }
        } else {
          dispatch(unsetLoader());
          dispatch(set_snack_bar(true, responseJson.message));
        }
      })
      .catch((error) => {
        dispatch(unsetLoader());
        dispatch(set_snack_bar(true, "Check Your Internet Connection"));
        console.error(error);
      });
  };
}